// extracted by mini-css-extract-plugin
module.exports = {"reviewContainer":"ReviewItem_reviewContainer__y1OPh","newReviewContainer":"ReviewItem_newReviewContainer__8MfkC","hideBorderBottom":"ReviewItem_hideBorderBottom___0hMi"};